import { action } from 'satcheljs';
import { AccountProviderType, OWAConnectedAccount } from 'owa-accounts-store';

/**
 * Connect a new account for OWA
 */
export const connectOWAAccount = action(
    'connectAccount',
    (accountProviderType: AccountProviderType) => ({
        accountProviderType,
    })
);

/**
 * Disconnect an account for OWA
 */
export const disconnectOWAAccount = action('disconnectAccount', (account: OWAConnectedAccount) => ({
    account,
}));

/**
 * Announces when an attempt to connect a new OWA connected account has failed
 */
export const connectOWAConnectedAccountFailed = action('connectOWAConnectedAccountFailed');

/**
 * Announces when an attempt to disconnect a new OWA connected account has failed
 */
export const disconnectOWAConnectedAccountFailed = action(
    'disconnectOWAConnectedAccountFailed',
    (primarySmtpAddress: string) => ({
        primarySmtpAddress,
    })
);

/**
 * Announces when an OWA Connected account has been disconncted
 */
export const connectedAccountDisconnected = action(
    'connectedAccountDisconnected',
    (primarySmtpAddress: string) => ({
        primarySmtpAddress,
    })
);

/**
 * Announces when an OWA Connected account has been connected
 */
export const accountConnected = action('accountConnected', (primarySmtpAddress: string) => ({
    primarySmtpAddress,
}));
